const TestimonialsList = [
    {
        testimonial: `I have been a client of this Sachin Anpat Sir for over six months, and the growth in my investments has been impressive compared to when I managed them personally. He has acutely and diligently distributed my funds based on my risk capacity and his expert insights. His personal attention is always available and patiently resolves all my doubts, reflecting their extensive experience in the field. The calls and advice provided are clear and highly professional. Highly recommended!
`,
        name: 'Atharva Tapkir',
        designation: 'Associate at Innoplexises'
    },
    {
        testimonial: `Over the past year, Sachin has not only delivered remarkable profits but also provided a level of personalized service that truly sets him apart. His thoughtful guidance and genuine commitment have made managing my investments a seamless experience. I wholeheartedly recommend Sachin to anyone looking for a skilled and dedicated portfolio manager.
`,
        name: 'Mayur Mundada',
        designation: 'IT Professional'
    },
    {
        testimonial: `Sachin Sir helped me to analyze various new technical and fundamental concepts about the stock market. He made investing very easy and simple. Wolf investment provides informative concepts about the stock market and keeps me up to date about global market changes. Made good profits through advisory/information provided by them.
`,
        name: 'Omkar Chitnis',
        designation: 'Associate at ARAI'
    },
    {
        testimonial: `It is a great experience working with Mr. Sachin Anpat. The way he takes the follow ups personally and looks after his clients is commendable. He has made investing in the Market way convenient and efficient.
`,
        name: 'Yash Mutha',
        designation: 'Graduate'
    }
    ,
    {
        testimonial: `I've been working with Sachin Anpat for 18 months, and I couldn’t be happier with the service. He is knowledgeable, responsive, and genuinely cares about my investment goals. Sachin’s expertise has helped me make informed decisions and achieve great returns. I highly recommend him to anyone looking for a reliable and skilled stock broker. Thank you, Sachin Anpat, for your exceptional service!`,
        name: 'Mayank Sawant',
        designation: 'IT Professional'
    },
    {
        testimonial: `I was blown away with the level of professionalism and expertise displayed by Sachin Anpat. Their knowledge in the industry is spot on. They maintain one on one communication with every client, educates the client where necessary, advises about the risks involved and guides them throughout the trading journey. Highly recommended!!`,
        name: 'Sagar Godbole',
        designation: 'Businessman'
    }
]

export default TestimonialsList;